"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbProvider = exports.BreadcrumbContext = void 0;
const react_1 = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
exports.BreadcrumbContext = (0, react_1.createContext)({
    breadcrumbs: [],
    registerBreadcrumb: () => 0,
    updateBreadcrumb: () => void {},
    removeBreadcrumb: () => void {},
    clearBreadcrumbs: () => void {}
});
/**
 * Breadcrumb Context Provider initializes the breadcrumb array and sets up
 * the methods for setting breadcrumb items.
 * @param props
 */
const BreadcrumbProvider = ({ children, initial = [] // default to empty array if not provided
 }) => {
    const [breadcrumbs, setBreadcrumbs] = (0, react_1.useState)(initial);
    const breadcrumbsRef = (0, react_1.useRef)(breadcrumbs);
    return (react_1.default.createElement(exports.BreadcrumbContext.Provider, { value: {
            breadcrumbs,
            registerBreadcrumb: (0, react_1.useCallback)(breadcrumb => {
                // setup the breadcrumb and return the index of the breadcrumb
                const index = breadcrumbsRef.current.length;
                if (breadcrumb) {
                    breadcrumb.index = index;
                }
                breadcrumbsRef.current.push(breadcrumb || { index, label: '' });
                setBreadcrumbs([...breadcrumbsRef.current]);
                // console.log('registerBreadcrumb', breadcrumb, index);
                return index;
            }, []),
            updateBreadcrumb: (0, react_1.useCallback)((index, breadcrumb) => {
                // find the breadcrumb and update it or insert at correct position;
                // insert is needed because breadcrumb may have been removed due to
                // unmount.
                const arrayIndex = breadcrumbsRef.current.findIndex(b => b.index === index);
                if (arrayIndex > -1) {
                    breadcrumbsRef.current[arrayIndex] = breadcrumb;
                }
                else {
                    breadcrumb.index = index;
                    breadcrumbsRef.current.splice(index, 0, breadcrumb);
                }
                // console.log('updateBreadcrumb', index, breadcrumbsRef.current);
                setBreadcrumbs([...breadcrumbsRef.current]);
            }, []),
            removeBreadcrumb: (0, react_1.useCallback)(index => {
                // console.log('removeBreadcrumb', index);
                const arrayIndex = breadcrumbsRef.current.findIndex(b => b.index === index);
                breadcrumbsRef.current.splice(arrayIndex, 1);
                setBreadcrumbs([...breadcrumbsRef.current]);
            }, []),
            clearBreadcrumbs: (0, react_1.useCallback)(() => {
                breadcrumbsRef.current.splice(0, breadcrumbsRef.current.length);
                setBreadcrumbs([]);
            }, [])
        } },
        react_1.default.createElement(react_helmet_1.default, { title: breadcrumbs.map(b => b.label).join(' / ') }),
        children));
};
exports.BreadcrumbProvider = BreadcrumbProvider;
//# sourceMappingURL=Breadcrumb.context.js.map